export default __webpack_public_path__ + "static/media/rabbit.66cc0edc.svg";